import React, { useContext } from 'react'
import styled from 'styled-components'
import { getAssetLink, liveHeaderHeight } from '../common/utils'
import i18n from 'live/services/i18n'
import { capitalize } from 'lodash'
import { ParamsContext } from './qualityMonitoring'
import { breadCrumbHeight } from './breadCrumb'

// export const TAB_TYPES = ['overview', 'sensorial']
export const TAB_TYPES = ['sensorial']
export function TabMenu(): JSX.Element {
    const urlParams = useContext(ParamsContext).split('/')
    const selectedTab = TAB_TYPES.includes(urlParams[0]) ? urlParams[0] : 'sensorial'

    return (
        <StyledTabMenu className={`tabMenu`}>
            {TAB_TYPES.map(tab => (
                <a
                    key={tab}
                    href={getAssetLink(getTabPath(tab, urlParams))}
                    className={`tabMenu--tabLink ${tab === selectedTab ? 'isSelected' : ''}`}
                >
                    {capitalize(i18n(tab))}
                </a>
            ))}
            <span className={`tabMenu--tabFiller`} />
        </StyledTabMenu>
    )
}

export function getTabPath(tabName: string, urlParams: string[]): string {
    const params = [...urlParams]
    params[0] = tabName

    return params.join('/')
}

const StyledTabMenu = styled.nav`
    --borderStyle: 1px solid ${({ theme }) => theme['gray-300']};
    width: 100%;
    background: ${({ theme }) => theme['gray-200']};
    font-size: 16px;
    height: ${breadCrumbHeight}px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: sticky;
    top: ${breadCrumbHeight + liveHeaderHeight}px;
    z-index: 2;
    .tabMenu {
        &--tabLink {
            color: ${({ theme }) => theme['gray-800']};
            text-decoration: none;
            padding: 14px 32px;
            border-bottom: var(--borderStyle);
            &.isSelected {
                border-bottom: none;
                background: ${({ theme }) => theme['gray-0']};
            }
            &:not(:first-child) {
                border-left: var(--borderStyle);
            }
        }
        &--tabFiller {
            flex-grow: 1;
            border-bottom: var(--borderStyle);
            border-left: var(--borderStyle);
            height: 100%;
        }
    }
`
